import React, {Component, Fragment} from 'react';
import {Redirect} from "react-router";
import {withTranslation} from "react-i18next";
import Loading from "../Parts/Loading";
import Header from "../Parts/Header";
import SubHeader from "../Parts/SubHeader";
import {toast} from "react-toastify";
import DidNotSignBy1Ct from "../../ErrorPages/DidNotSignBy1Ct";
import * as qs from "query-string";

class WaitingDocument extends Component {
    constructor(props) {
        super(props);

        const {match: {params}} = this.props;

        this.state = {
            showSuccessMessage: params.done === 'done',
            token: params.token,
            should_repeat: this.couldNotSignBy1Ct(),
        };

        this.checkDocument = this.checkDocument.bind(this);
        this.couldNotSignBy1Ct = this.couldNotSignBy1Ct.bind(this);
        this.checkDocument();
    }

    checkDocument() {

        axios.get('/api/remote_sign/' + this.state.token + '/check_document_status')
            .then(
                data => {
                    if (data.data.data.is_signed) {
                        gtm.sendEvent('auth', {
                            auth_method: 'esign',
                            status: 'OK',
                            auth_purpose: 'contract',
                        });

                        this.setState({showSuccessMessage: true});
                    } else {
                        gtm.sendEvent('auth', {
                            auth_method: 'esign',
                            status: 'Fail',
                            auth_purpose: 'contract',
                        });

                        setTimeout(this.checkDocument, 1500);
                    }
                },
                error => {
                    toast.error(error.response.data.message);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    couldNotSignBy1Ct() {
        let getParams = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});

        if (getParams.isOK === "Y") {
            return false;
        }

        if (getParams.isOK === "W") {
            return false;
        }

        if (getParams.isOK === "") {
            return false;
        }

        return getParams.isOK !== undefined;
    }

    render() {
        return (
            <Fragment>
                {!this.state.showSuccessMessage ?
                    <div>
                        {this.state.should_repeat ?
                            <DidNotSignBy1Ct url={'/sign_document/' + this.state.token}/>

                            :
                            <div>
                                <Header title={this.props.t('step.remote_sign_document')}/>

                                <div className="section window-layout">
                                    <div className="container frame">
                                        <SubHeader/>
                                        <Loading msg={this.props.t('forms.waiting_bank_response')}/>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    :

                    // Success message
                    <div>
                        <Header title={this.props.t('step.remote_sign_document')}/>

                        <div className="section window-layout">
                            <div className="container frame">
                                <div className="row py-5">
                                    <div className="container py-5">
                                        <div className="col-12 d-flex justify-content-center">
                                            <span className="success-icon"><i className="icons icon-check"></i></span>
                                        </div>
                                        <div className="col-12 d-flex justify-content-center text-center mt-4">
                                            <p className="heading--2">{this.props.t('forms.documents_were_signed_successfully')}</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}

export default withTranslation()(WaitingDocument);
